export default __webpack_public_path__ + "static/media/image.fleminco-pvt-ltd.3cc21216.png";